import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import { Priority } from './shared'
import { BugtrackerRequest } from '../../bugtrackers/api/shared'
import { getPriorities, GetPrioritiesArgs } from './requests/get-priorities'
import { buildApiPayloadBugtrackerCredentials } from '../../bugtrackers/api/build-api-payload-bugtracker-credentials'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface PrioritiesQueryProps {
  organizationUuid: string
  bugtrackerRequest: BugtrackerRequest | null
  projectName?: string
}

export interface PrioritiesQueryResponse {
  priorities?: Priority[]
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type PrioritiesQuery = (
  props: PrioritiesQueryProps
) => PrioritiesQueryResponse

export const usePrioritiesQuery: PrioritiesQuery = ({
  organizationUuid,
  bugtrackerRequest,
  projectName
}: PrioritiesQueryProps) => {
  const {
    data: priorities,
    isLoading,
    isError,
    error
  } = useContrastQuery<GetPrioritiesArgs, Priority[]>(
    [
      Query.INTEGRATIONS_PRIORITIES_JIRA,
      organizationUuid,
      bugtrackerRequest?.credentials_id
    ],
    getPriorities,
    {
      organizationUuid,
      bugtrackerRequest
    },
    {
      enabled:
        !!buildApiPayloadBugtrackerCredentials(bugtrackerRequest) &&
        !!projectName
    }
  )

  return {
    priorities,
    isLoading,
    isError,
    error
  }
}
